import { Tooltip } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import {InvalidationRuleServiceTypes} from '@bandido/shared/types';

interface ServiceTypeIconProps {
    type: InvalidationRuleServiceTypes;
}

export const ServiceTypeIcon = ({ type }: ServiceTypeIconProps) => {
  const { t } = useTranslation();

  const getIcon = (): ReactNode => {
    switch (type) {
    case InvalidationRuleServiceTypes.HOTELS:
      return <ApartmentIcon />;
    default:
      return null;
    }
  };

  return (
    <Tooltip title={t(`invalidationRules.serviceType.${type.toLowerCase()}`)}>
      <span>{getIcon()}</span>
    </Tooltip>
  );
};
